import React from 'react'

import { Input, InputContainer, Label } from '../styles'

type Props = {
  e2e: string
  label: React.ReactNode
  name: string
  onChange: (value: string) => void
  value: string
}
const MetadataInput = ({ e2e, label, name, onChange, value }: Props) => (
  <InputContainer>
    <Label>{label}</Label>
    <Input data-e2e={e2e} name={name} onChange={(e) => onChange(e.target.value)} value={value} />
  </InputContainer>
)

export default MetadataInput
